import { RequestDemoForm } from "@/components/forms";
import {
  wrapper,
  heading,
} from "@/components/mhealth-studio/get-in-touch/styles/get-in-touch-style";

const GetInTouchSection = () => {
  return (
    <div className={wrapper}>
      <h2 className={heading}>GET IN TOUCH</h2>
      <RequestDemoForm
        formId="mhealth-get-in-touch-form"
        formClassName="GA4-LeadConversion"
        translationPrefix="mhealth"
        themeColor={{
          color: "!text-[#04A9F4]",
          backgroundColor: "!bg-[#04A9F4]",
        }}
      />
    </div>
  );
};

export default GetInTouchSection;
